import React, { useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';
import { showAlert, validaRut } from '../../../../../../../lib/functions/utils';
import {
  createBusinessRelation,
  getRelatedBusiness,
} from '../../../../../../../lib/api/business';
interface CreateRelationDialogProps {
  open: boolean;
  onClose: () => void;
  businessFromIdentifier: string;
}

const CreateRelationDialog = ({
  open,
  onClose,
  businessFromIdentifier,
}: CreateRelationDialogProps) => {
  const dispatch = useDispatch();
  const [business, setBusiness] = useState<any>({
    name: '',
    identifier: '',
  });
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [businessExists, setBusinessExists] = useState(false);

  const handleSearch = async () => {
    const validRut = validaRut(business.identifier);
    if (!validRut) {
      alert('Rut inválido');
      return;
    }
    try {
      setLoading(true);
      const { businessTo, businessRelation } = await getRelatedBusiness(
        dispatch,
        businessFromIdentifier,
        business.identifier,
      );
      if (businessRelation) {
        showAlert(
          dispatch,
          'error',
          'La empresa ya existe como empresa relacionada',
        );
      } else {
        setBusiness(businessTo);
        setBusinessExists(businessTo);
        setSearched(true);
      }
    } catch (error) {
      setSearched(true);
      setBusinessExists(false);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: any) => {
    setBusiness({
      ...business,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'identifier') {
      setSearched(false);
      setBusinessExists(false);
    }
  };

  const handleCreate = async () => {
    try {
      setLoading(true);
      const response = await createBusinessRelation(
        dispatch,
        businessFromIdentifier,
        {
          businessToIdentifier: business.identifier,
          businessToName: business.name,
        },
      );
      if (response) {
        showAlert(
          dispatch,
          'success',
          'Empresa relacionada creada correctamente',
        );
        onClose();
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al crear la empresa relacionada');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle>Crear empresa relacionada</DialogTitle>
      {loading && <CenteredCircularProgress type="dialog" />}
      {!loading && (
        <DialogContent>
          {!searched && (
            <div>
              <Typography>
                Ingresa el rut para verificar si la emoresa existe antes de
                crear la relación.
              </Typography>
              <div
                style={{
                  padding: '10px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <TextField
                  name="identifier"
                  value={business.identifier}
                  onChange={handleChange}
                  placeholder="Rut"
                />
                <CustomButton
                  onClick={handleSearch}
                  color="primary"
                  variant="contained"
                >
                  Buscar
                </CustomButton>
              </div>
            </div>
          )}
          {searched && !businessExists && (
            <div>
              <Typography>
                La empresa no existe, por favor ingresa los datos de la empresa
                para crear la relación.
              </Typography>
              <div style={{ padding: '10px 0' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      name="name"
                      value={business.name}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      name="identifier"
                      value={business.identifier}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          )}
          {businessExists && (
            <div>
              <Typography>
                Vas a crear la siguiente empresa como una empresa relacionada
              </Typography>
              <Typography fontWeight="bold">
                {business.name} ({business.identifier})
              </Typography>
            </div>
          )}
          <DialogActions>
            <CustomButton
              onClick={handleCreate}
              color="primary"
              variant="contained"
              disabled={!business.name || !business.identifier}
            >
              Crear
            </CustomButton>
          </DialogActions>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default CreateRelationDialog;
